import { render, staticRenderFns } from "./QuestionnaireStepHeader.vue?vue&type=template&id=3a67d3f6&scoped=true&lang=pug"
import script from "./QuestionnaireStepHeader.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireStepHeader.vue?vue&type=script&lang=ts"
import style0 from "./QuestionnaireStepHeader.vue?vue&type=style&index=0&id=3a67d3f6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a67d3f6",
  null
  
)

export default component.exports